"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var form_definition_1 = require("../form-definition");
/**
 * this function takes a json form object and converts it into a Form object as defined above
 * @param {JsonForm} rawForm a json represenation of a TouchpointForm as defined in the participant portal
 */
function convertJsonForm(rawForm) {
    if (!rawForm) {
        return new form_definition_1.Form({});
    }
    var immutableElements;
    immutableElements = !!rawForm.elements ? rawForm.elements.map(function (element) { return form_definition_1.formElementTypes.convertToImmutable(element); }) : [];
    var immutableRules = !!rawForm.rules ?
        rawForm.rules.map(function (rule) { return new form_definition_1.formRuleTypes.ImmutableFormRule(rule); }) : [];
    return new form_definition_1.Form({
        id: rawForm.id,
        name: rawForm.name,
        heading: rawForm.heading,
        elements: immutable_1.List(immutableElements),
        rules: immutable_1.List(immutableRules),
        maxTotalAttachmentSize: rawForm.maxTotalAttachmentSize,
        includeRecaptcha: rawForm.includeRecaptcha,
    });
}
exports.convertJsonForm = convertJsonForm;
/**
 * Returns all elements that have isPreviewElement set to true
 * @param rawForm ssg form definition
 */
function getAllPreviewElements(rawForm) {
    if (!rawForm || !rawForm.elements)
        return [];
    var allElements = getAllElementsRecursive(rawForm.elements);
    return allElements.filter(function (element) { return element.isPreviewElement; });
}
exports.getAllPreviewElements = getAllPreviewElements;
/**
 * Returns all elements in the given form definition
 * @param rawForm ssg form definition
 */
function getAllElements(rawForm) {
    if (!rawForm || !rawForm.elements)
        return [];
    return getAllElementsRecursive(rawForm.elements);
}
exports.getAllElements = getAllElements;
function getAllElementsRecursive(elements) {
    var allElements = [];
    elements && elements.forEach(function (element, index) {
        switch (element.type) {
            case form_definition_1.elementTypes.group: {
                allElements.push.apply(allElements, getAllElementsRecursive(element.subElements));
            }
            default:
                allElements.push(element);
                break;
        }
    });
    return allElements;
}
/**
 * this function takes a Form and a json response object and converts it into the format that is expected to be in the
 * default values section of the FormsState
 * @param {JsonForm} form a json representation of an SSG Form
 * @param {JsonResponse} rawResponse a json representation of a TouchpointResponse as defined in the participant portal
 */
function convertJsonResponse(form, rawResponse) {
    var value = immutable_1.Map({});
    var ssgForm = convertJsonForm(form);
    var state = new form_definition_1.FormState({
        form: ssgForm
    });
    var elements = form_definition_1.getAllElementInfo(state);
    var elementResponses = rawResponse && rawResponse.elements;
    elementResponses && elementResponses.forEach(function (element) {
        var info = elements.find(function (info) { return info.element.id === element.id; });
        var formElement = info && info.element;
        if (!!formElement) {
            var elementValue = null;
            switch (formElement.type) {
                case form_definition_1.elementTypes.radio:
                case form_definition_1.elementTypes.checkbox:
                case form_definition_1.elementTypes.select:
                case form_definition_1.elementTypes.likert:
                    elementValue = !!element.value && immutable_1.List(element.value);
                    break;
                case form_definition_1.elementTypes.attachment: {
                    var files = element && element.value && element.value.files;
                    var convertedFiles = immutable_1.List(files || []).map(function (file) { return immutable_1.Map(file); });
                    elementValue = element && element.value && new form_definition_1.AttachmentResponseState(element.value);
                    elementValue = elementValue && elementValue.set('files', convertedFiles);
                    break;
                }
                case form_definition_1.elementTypes.time:
                    elementValue = new form_definition_1.TimeResponseState(element.value);
                    break;
                case form_definition_1.elementTypes.electronicSignature:
                    elementValue = new form_definition_1.ElectronicSignatureResponseState();
                    elementValue = elementValue.set('signInProgress', element.value.signInProgress);
                    if (element.value.etoCoords != null && element.value.etoCoords.length > 0) {
                        elementValue = elementValue.set('etoCoords', immutable_1.List(element.value.etoCoords));
                    }
                    else if (element.value.imageUrl != null) {
                        elementValue = elementValue.set('imageUrl', element.value.imageUrl);
                    }
                    elementValue = elementValue.set('signPadWidth', element.value.signPadWidth);
                    elementValue = elementValue.set('signPadHeight', element.value.signPadHeight);
                    break;
                case form_definition_1.elementTypes.emailNotification:
                    elementValue = new form_definition_1.EmailNotificationState(element.value);
                    break;
                default:
                    elementValue = element.value;
                    break;
            }
            value = value.set(element.id, elementValue);
        }
    });
    return value;
}
exports.convertJsonResponse = convertJsonResponse;
/**
 * Converts the answers in the form state into a simple js object that can be used for a PUT or POST request
 * @param format POST or PUT format
 *  the POST format will include all answers, including default values not set by the user
 *  the PUT format will only include values that the user changed directly
 * @param state the state of the form, including answers to the questions
 */
function processResponseState(format, state) {
    var form = state.form;
    var elements = form.elements;
    var response = {
        formId: form.id,
        elements: []
    };
    elements && elements.forEach(function (element) {
        var _a;
        var responses = processElementResponse(format, element, state);
        if (!!responses) {
            (_a = response.elements).push.apply(_a, responses);
        }
    });
    return response;
}
exports.processResponseState = processResponseState;
/**
 * recursive function that gets reponse values for an element
 * if it is a group element it will return all response values for all the sub elements as well
 * @param format POST or PUT format
 * @param element the element we are getting answers for
 * @param state the state of the form, including answers to the questions
 */
function processElementResponse(format, element, state) {
    var value = state.value;
    var responses = [];
    switch (element.type) {
        case form_definition_1.elementTypes.group:
            element.subElementsList && element.subElementsList.forEach(function (subElement) {
                var modifiedElement = form_definition_1.getModifiedSubElement(element, subElement);
                var subElementResponses = processElementResponse(format, modifiedElement, state);
                responses.push.apply(responses, subElementResponses);
            });
            break;
        default:
            if (!element.hidden && !element.disabled) {
                var responseValue = format === 'PUT' ?
                    value && value.get(element.id) :
                    form_definition_1.getValue(state, element.id);
                var response = {
                    id: element.id,
                    value: responseValue,
                };
                responses.push(response);
            }
            break;
    }
    return responses;
}
//# sourceMappingURL=json-adapters.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/adapters/json-adapters.js
// module id = 1165
// module chunks = 0